var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.deepGet(_vm.form, 'config.confirm_page.banner_image') ? _c('img', {
    staticClass: "banner-image w-100",
    attrs: {
      "src": _vm.deepGet(_vm.form, 'config.confirm_page.banner_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.deepGet(_vm.form, 'config.confirm_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.confirm_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.confirm_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.confirm_page.form_desc')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.confirm_page.content') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.form, 'config.confirm_page.content'))
    }
  }) : _vm._e(), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.isButtonDisabled
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]), _c('MemberButton', {
    staticClass: "mt-2",
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": "回 LINE 官方帳號",
      "button-url": "",
      "type": "OA"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }